import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from "../../../../environments/environment";
import { CmsService } from 'src/app/Services/cms.service';

@Component({
    selector: 'app-contactos',
    templateUrl: './contactos.component.html',
    standalone: false
})

export class ContactosComponent implements OnInit{
  phoneNumberGeneral: string;
  phoneLink: SafeUrl;

  // ---CMS---
  language: string = '';
  defaultLanguage: string = environment.defaultLanguage;
  contacts_content: string = 'linhas-contacto';
  contactsInfo: any = {};

  constructor(
    private cmsService: CmsService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    private title: Title
  ) {
    this.phoneNumberGeneral = environment.phoneNumberGeneral;
    this.phoneLink = this.sanitizer.bypassSecurityTrustUrl(`tel:${environment.phoneNumberGeneralClean}`);

    let lang = localStorage.getItem('language') ?? this.defaultLanguage;
    this.language = lang.split('-')[0];

    this.translate.get('navLinks').pipe().subscribe(trans => {
      let pageTitle =  trans['linhas'] + ' | ' + trans['contactos']
      this.title.setTitle(pageTitle);
    })
  }

  ngOnInit(){
    this.getContent();
  }

  getContent(){
    this.cmsService.getContentList(this.contacts_content, this.language).subscribe(
      {
        next: data => {
          this.contactsInfo = data['body']['data'];

        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }
}
